import { debounce} from 'lodash';
import Browser from '../Browser';

function autocompleteClientSide(input, google) {
  return new Promise((resolve, reject) => {
    const service = new google.maps.places.AutocompleteService();
    service.getPlacePredictions({
      input,
      componentRestrictions: { country: 'us' },
    }, (predictions, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        reject(status);
      } else {
        resolve(predictions);
      }
    });
  });
}

async function autocompleteServerSide(input, coreApiClientBase) {
  const response = await coreApiClientBase.get('/places', {
    params: {
      search: input,
    },
  });
  return response.data;
}

export function autocomplete({ input, google, coreApiClientBase }) {
  const parsedInput = input.trim();
  if (!parsedInput) {
    return Promise.resolve([]);
  }

  if (Browser.isIe11()) {
    return autocompleteServerSide(input, coreApiClientBase);
  }
  return autocompleteClientSide(input, google);
}

// Lodash debounce doesn't work well with promises, so we need this alternative version.
function callbackAutocomplete(params, callback) {
  autocomplete(params).then((response) => {
    callback(null, response);
  }).catch((error) => {
    callback(error, null);
  });
}

const debouncedCallbackAutocomplete = debounce(callbackAutocomplete, 200);

export function debouncedAutocomplete(params) {
  return new Promise((resolve, reject) => {
    debouncedCallbackAutocomplete(params, (error, response) => {
      if (error) {
        reject(error);
        return [];
      } else {
        resolve(response);
      }
    },
    );
  });
}
